// import React, { useEffect, useState, useCallback } from "react";
// import { Row, Col, Card } from "react-bootstrap";
// import api from "../../api";
// import DashboardFilterBar from "../../components/dashboard/DashboardFilterBar";
// import DataQualityNotice from "../../components/dashboard/DataQualityNotice";
// import MetricCard from "../../components/dashboard/MetricCard";

// // Phase 5, §30. "Organization Dashboard" — Admin/authorized only
// // (dashboards:view_organization). Totals only, no per-employee ranking.
// export default function OrganizationDashboardPage() {
//   const [filters, setFilters] = useState({});
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [accessDenied, setAccessDenied] = useState(false);

//   const fetchSummary = useCallback(async () => {
//     setLoading(true);
//     setAccessDenied(false);
//     try {
//       const res = await api.get("/dashboards/organization-summary", { params: filters });
//       setData(res.data?.data || null);
//     } catch (err) {
//       if (err.response?.status === 403) setAccessDenied(true);
//       console.error("Fetch organization-summary error:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [filters]);

//   useEffect(() => { fetchSummary(); }, [fetchSummary]);

//   if (accessDenied) {
//     return (
//       <div className="unit-page dashboard-shell">
//         <div className="unit-empty">
//           <div className="unit-empty-icon"><i className="fa-solid fa-lock" aria-hidden="true"></i></div>
//           <h5>Access denied</h5>
//           <p>You do not have permission to view the organization dashboard.</p>
//         </div>
//       </div>
//     );
//   }

//   const cards = data?.summaryCards || {};

//   return (
//     <div className="unit-page dashboard-shell">
//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Performance</div>
//           <h2>Organization Dashboard</h2>
//           <p>Organization-wide totals across tasks, forms, UAT and approvals.</p>
//         </div>
//       </div>

//       <DashboardFilterBar filters={filters} onChange={setFilters} />

//       {loading ? (
//         <div className="perf-skeleton-row">
//           {[0, 1, 2, 3].map((i) => <div key={i} className="perf-skeleton-card" />)}
//         </div>
//       ) : (
//         <>
//           <DataQualityNotice warnings={data?.warnings} />

//           <Card className="perf-section-card"><Card.Body>
//             <h6 className="perf-section-title"><i className="fa-solid fa-list-check" aria-hidden="true"></i>Task Totals</h6>
//             <Row className="g-3">
//               <Col xs={6} md={3}><MetricCard label="Assigned" value={cards.taskTotals?.tasksAssigned} direction="INFORMATIONAL_ONLY" icon="fa-list-check" /></Col>
//               <Col xs={6} md={3}><MetricCard label="Completed" value={cards.taskTotals?.tasksCompleted} direction="HIGHER_IS_BETTER" icon="fa-circle-check" /></Col>
//               <Col xs={6} md={3}><MetricCard label="Open" value={cards.taskTotals?.tasksOpen} direction="INFORMATIONAL_ONLY" icon="fa-folder-open" accent="warning" /></Col>
//               <Col xs={6} md={3}><MetricCard label="Overdue" value={cards.taskTotals?.tasksOverdue} direction="LOWER_IS_BETTER" icon="fa-triangle-exclamation" /></Col>
//             </Row>
//           </Card.Body></Card>

//           <Card className="perf-section-card"><Card.Body>
//             <h6 className="perf-section-title"><i className="fa-solid fa-file-lines" aria-hidden="true"></i>Form Totals</h6>
//             <Row className="g-3">
//               <Col xs={6} md={4}><MetricCard label="Assigned" value={cards.formTotals?.formsAssigned} direction="INFORMATIONAL_ONLY" icon="fa-file-lines" /></Col>
//               <Col xs={6} md={4}><MetricCard label="Submitted" value={cards.formTotals?.formsSubmitted} direction="HIGHER_IS_BETTER" icon="fa-circle-check" /></Col>
//               <Col xs={6} md={4}><MetricCard label="Submitted On Time" value={cards.formTotals?.formsSubmittedOnTime} direction="HIGHER_IS_BETTER" icon="fa-clock" /></Col>
//             </Row>
//           </Card.Body></Card>

//           <Card className="perf-section-card"><Card.Body>
//             <h6 className="perf-section-title"><i className="fa-solid fa-clipboard-check" aria-hidden="true"></i>UAT Totals</h6>
//             <Row className="g-3">
//               <Col xs={6} md={4}><MetricCard label="Submissions" value={cards.uatTotals?.uatSubmissions} direction="INFORMATIONAL_ONLY" icon="fa-vial" /></Col>
//               <Col xs={6} md={4}><MetricCard label="Failed Cases" value={cards.uatTotals?.failedCases} direction="LOWER_IS_BETTER" icon="fa-triangle-exclamation" /></Col>
//               <Col xs={6} md={4}><MetricCard label="Linked Defects" value={cards.uatTotals?.linkedDefects} direction="INFORMATIONAL_ONLY" icon="fa-bug" /></Col>
//             </Row>
//           </Card.Body></Card>

//           <Card className="perf-section-card"><Card.Body>
//             <h6 className="perf-section-title"><i className="fa-solid fa-user-check" aria-hidden="true"></i>Approval Totals</h6>
//             <Row className="g-3">
//               <Col xs={6} md={4}><MetricCard label="Requests Raised" value={cards.approvalTotals?.requestsRaised} direction="INFORMATIONAL_ONLY" icon="fa-paper-plane" /></Col>
//               <Col xs={6} md={4}><MetricCard label="Approved" value={cards.approvalTotals?.approvedCount} direction="INFORMATIONAL_ONLY" icon="fa-circle-check" /></Col>
//               <Col xs={6} md={4}><MetricCard label="Pending" value={cards.approvalTotals?.pendingCount} direction="INFORMATIONAL_ONLY" icon="fa-hourglass-half" /></Col>
//             </Row>
//           </Card.Body></Card>
//         </>
//       )}
//     </div>
//   );
// }






import React, { useEffect, useState, useCallback } from "react";

import { Row, Col, Card } from "react-bootstrap";

import api from "../../api";

import DashboardFilterBar from "../../components/dashboard/DashboardFilterBar";

import DataQualityNotice from "../../components/dashboard/DataQualityNotice";

import MetricCard from "../../components/dashboard/MetricCard";



// Phase 5, §30. "Organization Dashboard" — Admin/authorized only
// (dashboards:view_organization). Totals only, no per-employee ranking.
export default function OrganizationDashboardPage() {
  const [filters, setFilters] = useState({});

  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(false);

  const [accessDenied, setAccessDenied] = useState(false);

  const fetchSummary = useCallback(async () => {
    setLoading(true);

    setAccessDenied(false);

    try {
      const res = await api.get("/dashboards/organization-summary", { params: filters });

      setData(res.data?.data || null);
    } catch (err) {
      if (err.response?.status === 403) setAccessDenied(true);

      console.error("Fetch organization-summary error:", err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => { fetchSummary(); }, [fetchSummary]);

  if (accessDenied) {
    return (
      <div className="unit-page dashboard-shell organization-perf-theme">
        <div className="unit-empty">
          <div className="unit-empty-icon"><i className="fa-solid fa-lock" aria-hidden="true"></i></div>

          <h5>Access denied</h5>

          <p>You do not have permission to view the organization dashboard.</p>
        </div>
      </div>
    );
  }

  const cards = data?.summaryCards || {};

  return (
    <div className="unit-page dashboard-shell organization-perf-theme">
      <div className="unit-header">
        <div>
          <div className="unit-page-label">Performance</div>

          <h2>Organization Dashboard</h2>

          <p>Organization-wide totals across tasks, forms, UAT and approvals.</p>
        </div>
      </div>

      <DashboardFilterBar filters={filters} onChange={setFilters} />

      {loading ? (
        <div className="perf-skeleton-row">
          {[0, 1, 2, 3].map((i) => <div key={i} className="perf-skeleton-card" />)}
        </div>
      ) : (
        <>
          <DataQualityNotice warnings={data?.warnings} />

          <Card className="perf-section-card"><Card.Body>
            <h6 className="perf-section-title"><i className="fa-solid fa-list-check" aria-hidden="true"></i>Task Totals</h6>

            <Row className="g-3">
              <Col xs={6} md={3}><MetricCard label="Assigned" value={cards.taskTotals?.tasksAssigned} direction="INFORMATIONAL_ONLY" icon="fa-list-check" /></Col>
              <Col xs={6} md={3}><MetricCard label="Completed" value={cards.taskTotals?.tasksCompleted} direction="HIGHER_IS_BETTER" icon="fa-circle-check" /></Col>
              <Col xs={6} md={3}><MetricCard label="Open" value={cards.taskTotals?.tasksOpen} direction="INFORMATIONAL_ONLY" icon="fa-folder-open" accent="warning" /></Col>
              <Col xs={6} md={3}><MetricCard label="Overdue" value={cards.taskTotals?.tasksOverdue} direction="LOWER_IS_BETTER" icon="fa-triangle-exclamation" /></Col>
            </Row>
          </Card.Body></Card>

          <Card className="perf-section-card"><Card.Body>
            <h6 className="perf-section-title"><i className="fa-solid fa-file-lines" aria-hidden="true"></i>Form Totals</h6>

            <Row className="g-3">
              <Col xs={6} md={4}><MetricCard label="Assigned" value={cards.formTotals?.formsAssigned} direction="INFORMATIONAL_ONLY" icon="fa-file-lines" /></Col>
              <Col xs={6} md={4}><MetricCard label="Submitted" value={cards.formTotals?.formsSubmitted} direction="HIGHER_IS_BETTER" icon="fa-circle-check" /></Col>
              <Col xs={6} md={4}><MetricCard label="Submitted On Time" value={cards.formTotals?.formsSubmittedOnTime} direction="HIGHER_IS_BETTER" icon="fa-clock" /></Col>
            </Row>
          </Card.Body></Card>

          <Card className="perf-section-card"><Card.Body>
            <h6 className="perf-section-title"><i className="fa-solid fa-clipboard-check" aria-hidden="true"></i>UAT Totals</h6>

            <Row className="g-3">
              <Col xs={6} md={4}><MetricCard label="Submissions" value={cards.uatTotals?.uatSubmissions} direction="INFORMATIONAL_ONLY" icon="fa-vial" /></Col>
              <Col xs={6} md={4}><MetricCard label="Failed Cases" value={cards.uatTotals?.failedCases} direction="LOWER_IS_BETTER" icon="fa-triangle-exclamation" /></Col>
              <Col xs={6} md={4}><MetricCard label="Linked Defects" value={cards.uatTotals?.linkedDefects} direction="INFORMATIONAL_ONLY" icon="fa-bug" /></Col>
            </Row>
          </Card.Body></Card>

          <Card className="perf-section-card"><Card.Body>
            <h6 className="perf-section-title"><i className="fa-solid fa-user-check" aria-hidden="true"></i>Approval Totals</h6>

            <Row className="g-3">
              <Col xs={6} md={4}><MetricCard label="Requests Raised" value={cards.approvalTotals?.requestsRaised} direction="INFORMATIONAL_ONLY" icon="fa-paper-plane" /></Col>
              <Col xs={6} md={4}><MetricCard label="Approved" value={cards.approvalTotals?.approvedCount} direction="INFORMATIONAL_ONLY" icon="fa-circle-check" /></Col>
              <Col xs={6} md={4}><MetricCard label="Pending" value={cards.approvalTotals?.pendingCount} direction="INFORMATIONAL_ONLY" icon="fa-hourglass-half" /></Col>
            </Row>
          </Card.Body></Card>
        </>
      )}
    </div>
  );
}
